export default __webpack_public_path__ + "static/media/Chestguard of the Proven Champion.6d578596.jpg";